// extracted by mini-css-extract-plugin
export default {"hidePlayList":"VideoEmbed_hidePlayList__95OO7","loadingSpinner":"VideoEmbed_loadingSpinner__HJSMP"};